/* ── Page Loader ─────────────────────────────────────── */
(function () {
  var loader = document.getElementById('dj-loader');
  if (!loader) return;

  document.body.classList.add('dj-loading');

  var MIN_MS = 3200; // minimum 3.2 seconds visible
  var startAt = Date.now();

  function dismissLoader() {
    var elapsed = Date.now() - startAt;
    var wait = Math.max(0, MIN_MS - elapsed);
    setTimeout(function () {
      loader.classList.add('dj-loader--out');
      document.body.classList.remove('dj-loading');
      setTimeout(function () {
        loader.remove();
      }, 750); // matches CSS transition duration
    }, wait);
  }

  if (document.readyState === 'complete') {
    dismissLoader();
  } else {
    window.addEventListener('load', dismissLoader, { once: true });
  }
}());
/* ── End Page Loader ─────────────────────────────────── */

/**
 * DiskJokey — GSAP + ScrollTrigger (see .cursorrules v3)
 * Runs only on the Shopify home template (template-index).
 *
 * Policy: scroll-triggered animations use autoAlpha (not opacity) with
 * immediateRender: false so above-the-fold content is never stuck hidden.
 */
(function () {
  'use strict';

  // In Shopify theme editor the preview runs inside an iframe.
  // Skip all GSAP and force everything visible — iframe check is synchronous
  // and never fails, unlike window.Shopify.designMode which can be async.
  if (window.self !== window.top) {
    document.documentElement.classList.add('dj-no-anim');
    return;
  }

  if (!document.body.classList.contains('template-index')) {
    return;
  }

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var navbar = document.querySelector('.navbar');
  if (navbar) {
    var onNavScroll = function () {
      if (window.scrollY > 80) {
        navbar.classList.add('navbar--scrolled');
      } else {
        navbar.classList.remove('navbar--scrolled');
      }
    };
    onNavScroll();
    window.addEventListener('scroll', onNavScroll, { passive: true });
  }

  /* ── Mobile menu toggle ─────────────────────────── */
  var mobileToggle = document.getElementById('nav-mobile-toggle');
  var mobileMenu   = document.getElementById('nav-mobile-menu');

  // Create backdrop dynamically on <body> so it's never clipped by a section wrapper
  var mobileBackdrop = document.createElement('div');
  mobileBackdrop.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.82);z-index:9998;pointer-events:none;';
  document.body.appendChild(mobileBackdrop);

  function openMobileMenu() {
    mobileMenu.classList.add('is-open');
    mobileToggle.classList.add('is-open');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    mobileBackdrop.style.display = 'block';
    mobileBackdrop.style.pointerEvents = 'auto';
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('is-open');
    mobileToggle.classList.remove('is-open');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    mobileBackdrop.style.display = 'none';
    mobileBackdrop.style.pointerEvents = 'none';
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileMenu.classList.contains('is-open') ? closeMobileMenu() : openMobileMenu();
    });

    mobileMenu.querySelectorAll('.nav-mobile-link').forEach(function (link) {
      link.addEventListener('click', closeMobileMenu);
    });

    mobileBackdrop.addEventListener('click', closeMobileMenu);
  }
  /* ── End mobile menu ─────────────────────────────── */

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    var id = anchor.getAttribute('href');
    if (!id || id === '#') return;
    anchor.addEventListener('click', function (e) {
      if (prefersReducedMotion) return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Scroll-hint div is not an anchor so the loop above never touches it.
  // Find the section immediately after #hero and scroll to it on click.
  var scrollHint = document.querySelector('.hero-scroll-hint');
  if (scrollHint) {
    scrollHint.style.cursor = 'pointer';
    scrollHint.addEventListener('click', function () {
      if (prefersReducedMotion) return;
      var heroWrap = document.querySelector('#hero');
      var next = heroWrap
        && (heroWrap.closest('.shopify-section') || heroWrap).nextElementSibling;
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  if (prefersReducedMotion) {
    return;
  }

  var mm = gsap.matchMedia();

  mm.add('(prefers-reduced-motion: no-preference) and (min-width: 769px)', function () {
    function runHeroLoad() {
      if (!document.querySelector('.hero-tagline')) return;
      var heroTl = gsap.timeline({
        defaults: { ease: 'power3.out', immediateRender: false },
      });
      if (document.querySelector('.nav-logo')) {
        heroTl.from('.nav-logo', { autoAlpha: 0, y: -20, duration: 0.6 });
      }
      heroTl
        .from('.hero-eyebrow', { autoAlpha: 0, y: 14, duration: 0.45 }, '-=0.25')
        .from('.hero-tagline', { autoAlpha: 0, y: 50, duration: 0.9 }, '-=0.2')
        .from('.hero-sub', { autoAlpha: 0, y: 30, duration: 0.7 }, '-=0.5')
        .from('.hero-cta', { autoAlpha: 0, y: 20, duration: 0.6 }, '-=0.4')
        .from('.hero-scroll-hint', { autoAlpha: 0, y: 10, duration: 0.5 }, '-=0.3');

      // Safety: if timeline stalls (slow mobile), force hero visible after 1.5s
      setTimeout(function () {
        document.querySelectorAll(
          '.hero-tagline, .hero-eyebrow, .hero-sub, .hero-cta, .hero-scroll-hint, .nav-logo'
        ).forEach(function (el) {
          if (parseFloat(window.getComputedStyle(el).opacity) < 0.1) {
            el.style.removeProperty('opacity');
            el.style.removeProperty('visibility');
            el.style.removeProperty('transform');
          }
        });
      }, 1500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runHeroLoad);
    } else {
      runHeroLoad();
    }

    /* ── Entrance + exit animations with toggleActions: play none none reverse ── */

    gsap.utils.toArray('.reveal').forEach(function (el, i) {
      if (el.closest('.clients-grid')) return;
      if (el.classList.contains('section-title')) return;
      if (el.classList.contains('form-field')) return;
      if (el.classList.contains('footer-reveal')) return;
      if (el.classList.contains('featured-partner')) return;

      var fromVars = {
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          end: 'top 15%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        duration: 0.8,
        ease: 'power2.out',
        delay: i * 0.04,
      };

      if (el.classList.contains('reveal--left')) {
        fromVars.x = -50;
      } else if (el.classList.contains('reveal--right')) {
        fromVars.x = 50;
      } else {
        fromVars.y = 40;
      }

      gsap.from(el, fromVars);
    });

    /* Section titles — slide in from left, reverse on exit */
    gsap.utils.toArray('.section-title').forEach(function (el) {
      if (el.closest('.about, .process, .genres')) return;

      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        x: -60,
        duration: 0.9,
        ease: 'power3.out',
      });
    });

    /* Section labels — fade up */
    gsap.utils.toArray('.section-label').forEach(function (el) {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 20,
        duration: 0.6,
        ease: 'power2.out',
      });
    });

    /* Featured partner — scale + fade entrance with exit */
    if (document.querySelector('.featured-partner')) {
      gsap.from('.featured-partner', {
        scrollTrigger: {
          trigger: '.featured-partner',
          start: 'top 80%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 40,
        duration: 1,
        ease: 'power3.out',
      });
      gsap.from('.featured-partner-logo img', {
        scrollTrigger: {
          trigger: '.featured-partner',
          start: 'top 75%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        scale: 0.85,
        duration: 0.9,
        ease: 'back.out(1.4)',
        delay: 0.2,
      });
    }

    /* Client cards — staggered rise with exit */
    if (document.querySelector('.clients-grid')) {
      gsap.from('.client-card', {
        scrollTrigger: {
          trigger: '.clients-grid',
          start: 'top 80%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 56,
        stagger: 0.1,
        duration: 0.65,
        ease: 'power2.out',
      });
    }

    /* Process steps — staggered slide up */
    if (document.querySelector('.process-steps')) {
      gsap.from('.process-step', {
        scrollTrigger: {
          trigger: '.process-steps',
          start: 'top 82%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 60,
        stagger: 0.15,
        duration: 0.7,
        ease: 'power3.out',
      });
    }

    /* Genre tags — staggered pop in */
    if (document.querySelector('.genres-grid')) {
      gsap.from('.genre-tag', {
        scrollTrigger: {
          trigger: '.genres-grid',
          start: 'top 85%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        scale: 0.8,
        y: 20,
        stagger: 0.03,
        duration: 0.45,
        ease: 'back.out(1.6)',
      });
    }

    /* Stat items — staggered count-in entrance */
    if (document.querySelector('.stats-bar')) {
      gsap.from('.stat-item', {
        scrollTrigger: {
          trigger: '.stats-bar',
          start: 'top 85%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 30,
        stagger: 0.12,
        duration: 0.6,
        ease: 'power2.out',
      });
    }

    /* About text + image — slide in from sides */
    if (document.querySelector('.about-text')) {
      gsap.from('.about-text', {
        scrollTrigger: {
          trigger: '.about',
          start: 'top 75%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        x: -60,
        duration: 0.9,
        ease: 'power3.out',
      });
    }
    if (document.querySelector('.about-image')) {
      gsap.from('.about-image', {
        scrollTrigger: {
          trigger: '.about',
          start: 'top 75%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        x: 60,
        duration: 0.9,
        ease: 'power3.out',
        delay: 0.15,
      });
    }

    /* Manifesto — scale up entrance */
    if (document.querySelector('.manifesto-content')) {
      gsap.from('.manifesto-content', {
        scrollTrigger: {
          trigger: '.manifesto',
          start: 'top 70%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        scale: 0.92,
        y: 30,
        duration: 1,
        ease: 'power3.out',
      });
    }

    /* Hero parallax */
    if (document.querySelector('.hero-bg')) {
      gsap.to('.hero-bg', {
        scrollTrigger: {
          trigger: '.hero',
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
        y: '30%',
        ease: 'none',
      });
    }

    if (document.querySelector('.vinyl-ring')) {
      gsap.to('.vinyl-ring', {
        rotation: 360,
        duration: 80,
        ease: 'none',
        repeat: -1,
        transformOrigin: '50% 50%',
      });
    }

    /* Contact form fields — staggered rise with exit */
    if (document.querySelector('.contact-form')) {
      gsap.from('.contact-form .form-field', {
        scrollTrigger: {
          trigger: '.contact-form',
          start: 'top 88%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 28,
        stagger: 0.1,
        duration: 0.55,
        ease: 'power2.out',
      });
    }

    /* Submit button — pop in */
    if (document.querySelector('.submit-btn')) {
      gsap.from('.submit-btn', {
        scrollTrigger: {
          trigger: '.submit-btn',
          start: 'top 92%',
          end: 'top 10%',
          toggleActions: 'play none none reverse',
        },
        autoAlpha: 0,
        immediateRender: false,
        scale: 0.9,
        y: 20,
        duration: 0.5,
        ease: 'back.out(1.4)',
      });
    }

    /* Footer — staggered columns */
    gsap.utils.toArray('.footer-reveal').forEach(function (el, i) {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top 94%',
        },
        autoAlpha: 0,
        immediateRender: false,
        y: 48,
        duration: 0.8,
        ease: 'power2.out',
        delay: i * 0.07,
      });
    });

    ScrollTrigger.refresh();
  });

  /* ── Stats counter — runs on ALL screen sizes ── */
  if (document.querySelector('.stats-bar')) {
    var statsDone = false;
    document.querySelectorAll('.stat-number').forEach(function (el) {
      var raw = el.getAttribute('data-target');
      el.textContent = raw || el.textContent;
    });
    function runStats() {
      if (statsDone) return;
      var bar = document.querySelector('.stats-bar');
      if (!bar) return;
      var rect = bar.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        statsDone = true;
        document.querySelectorAll('.stat-number').forEach(function (el) {
          var target = parseInt(el.getAttribute('data-target'), 10);
          if (isNaN(target)) return;
          var start = null;
          var duration = 1800;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var ease = 1 - Math.pow(1 - progress, 3);
            el.textContent = String(Math.round(ease * target));
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
        window.removeEventListener('scroll', runStats);
      }
    }
    window.addEventListener('scroll', runStats, { passive: true });
    runStats();
  }
  /* ── End stats counter ── */

  var djForm = document.getElementById('DJContactForm');
  if (djForm) {
    djForm.addEventListener('submit', function () {
      var company = document.getElementById('DJContactForm-company');
      var body = document.getElementById('DJContactForm-body');
      if (company && body && body.name === 'contact[body]') {
        var c = company.value.trim();
        var m = body.value.trim();
        if (c) {
          body.value = 'Company: ' + c + (m ? '\n\n' + m : '');
        }
      }
    });
  }
})();
